import { call, put, takeLatest } from 'redux-saga/effects';

import * as schedulerActions from './schedulerActions.js';
import { getSchedulerDraftApiCall, updateSchedulerApiCall } from './schedulerAPI.js';

function* updateSchedulerSaga({ payload }) {
  try {
    const { data } = yield call(updateSchedulerApiCall, payload);
    yield put(schedulerActions.schedulerUpdateStore(data));
  } catch (error) {
    yield put(schedulerActions.schedulerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* getDraftSchedulerSaga({ payload }) {
  console.log(payload);

  const { id, navigate, profileId } = payload;

  try {
    const { data } = yield call(getSchedulerDraftApiCall, id, profileId);
    yield put(schedulerActions.schedulerGetDraftStore(data));
    navigate(`/social-planner/post/${id}`);
    //
    // yield takeEvery(FOO, function*(action) {
    //   action.navigate('/foo')
    // })
  } catch (error) {
    yield put(schedulerActions.schedulerGetDraftError(error.Message ? error.Message : error.toString()));
  }
}

export function* schedulerWatcher() {
  yield takeLatest(schedulerActions.schedulerUpdateRequest.type, updateSchedulerSaga);
}

export function* getDraftSchedulerWatcher() {
  yield takeLatest(schedulerActions.schedulerGetDraftRequest.type, getDraftSchedulerSaga);
}
